import { CardElement as CardElementOrg } from 'react-stripe-elements'
import styled from 'styled-components'
import { inputCss } from 'components/Elements/index'

const StyledCardElement = styled(CardElementOrg).attrs(props => ({
  hidePostalCode: true,
  style: { base: { fontSize: '16px' } }
}))`
  background: #fff;
  padding: 0.6rem;
  font-size: 2rem;
  ${inputCss}
`

export default StyledCardElement
